import { Card, Typography, Tooltip } from "antd";
import { FileDoneOutlined, TeamOutlined, AppstoreOutlined, ShoppingOutlined } from "@ant-design/icons";
const { Text } = Typography;

export default function EntregasPOCards({ stats }) {

  const formatNumber = (num) => new Intl.NumberFormat("es-CO").format(Number(num || 0));

  const formatCompact = (num) => {
    num = Number(num || 0);
    if (num >= 1000000000) return (num / 1000000000).toFixed(1) + "B";
    if (num >= 1000000) return (num / 1000000).toFixed(1) + "M";
    if (num >= 1000) return (num / 1000).toFixed(1) + "K";
    return num;
  };

  const cards = [
    { title: "Actas de entrega", value: stats?.total_actas, description: "Actas registradas (beneficiario + fecha + bodega)", icon: <FileDoneOutlined />, color: "#1677ff" },
    { title: "Beneficiarios", value: stats?.total_beneficiarios, description: "Participantes u organizaciones distintos con al menos una entrega", icon: <TeamOutlined />, color: "#52c41a" },
    { title: "Productos entregados", value: stats?.total_productos, description: "Productos distintos que han sido entregados", icon: <AppstoreOutlined />, color: "#722ed1" },
    { title: "Unidades entregadas", value: stats?.total_cantidad, description: "Suma de cantidades entregadas", icon: <ShoppingOutlined />, color: "#faad14" }
  ];

  return (
    <div style={{ display: "flex", gap: 16, marginBottom: 24, flexWrap: "wrap" }}>
      {cards.map((card, i) => (
        <Card key={i} hoverable style={{ flex: "1 1 200px", borderRadius: 12, padding: 14, boxShadow: "0 4px 10px rgba(0,0,0,0.05)" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <Text style={{ color: "#6b7280", fontSize: 13, display: "block", marginBottom: 6 }}>{card.title}</Text>
              <Tooltip title={`${card.description}: ${formatNumber(card.value)}`}>
                <div style={{ fontSize: 26, fontWeight: 700, color: "#111827", cursor: "help" }}>
                  {formatCompact(card.value)}
                </div>
              </Tooltip>
            </div>
            <div style={{ background: card.color + "20", color: card.color, width: 48, height: 48, borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>
              {card.icon}
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
